/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { mediaResolutions } from "@adapptio/lib-components";
import { MEDIA_RESOLUTIONS_string } from "@adapptio/lib-blueprint";
import { IDropdownMenuItem } from "../ui/components/DropdownMenu";

export type TPreviewResolutionId = MEDIA_RESOLUTIONS_string; // | TCustomMediaResolutionKey;

export const DEFAULT_PREVIEW_RESOLUTION_ID: TPreviewResolutionId = "screenBase";
export const BASE_PREVIEW_RESOLUTION_ID: TPreviewResolutionId = "screenBase"; // Always BASE !
export const PRINT_PREVIEW_RESOLUTION_ID: TPreviewResolutionId = "print";

export const PREVIEW_RESOLUTION_SETTINGS_STORAGE_KEY = "previewResolution.settings";

const availablePreviewResolutions = [ ...mediaResolutions.entries() ].filter(
	([ key ]) => key !== PRINT_PREVIEW_RESOLUTION_ID
);

export const previewResolutions = new Map(availablePreviewResolutions);
export const previewResolutionsOptions: IDropdownMenuItem[] = availablePreviewResolutions.map(
	([ id, resolution ]) => ({
		id,
		label: resolution.label,
		icon: resolution.icon
	})
);

export interface IPreviewResolutionSettings {
	selectedPreviewResolutionId: TPreviewResolutionId;
	manualWidths: Partial<Record<TPreviewResolutionId, number>>;
}

export const defaultPreviewResolutionSettings: IPreviewResolutionSettings = {
	selectedPreviewResolutionId: DEFAULT_PREVIEW_RESOLUTION_ID,
	manualWidths: {}
};
